import * as faceapi from "face-api.js";
import {GrmMediaPipeObject, GrmMediaPipeInterface} from "@/lib/gooroomee/mediapipe/grm-mediapipe/GrmMediaPipeInterface";

export default class GrmFaceDetector extends GrmMediaPipeInterface {
    confidence = {
        detected: 1, // 최초는 pass
        lastDetectedTime: 0,
        cooldownTime: 500,
        reset () {
            Object.assign(this, {
                detected: 0,
                lastDetectedTime: 0,
            });
        },
        isAreaDetected (canvas, box, ratio) {
            const {width, height} = canvas;
            const widthPadding = (width - (width * ratio)) / 2;
            const heightPadding = (height - (height * ratio)) / 2;

            // const faceCenterX = box.x + box.width / 2;
            // const faceCenterY = box.y + box.height / 2;
            // const result = faceCenterX > widthPadding && faceCenterX < width - widthPadding
            //         && faceCenterY > heightPadding && faceCenterY < height - heightPadding

            const inX = box.x > widthPadding && box.x+box.width < width - widthPadding;
            const inY = box.y > heightPadding && box.y+box.height < height - heightPadding;
            const result = inX && inY;
            // if(!result){
            //     console.log('@@@ calc area: x[%s, %s~%s, %s~%s] y[%s, %s~%s, %s~%s]',
            //         inX, box.x, box.x+box.width, widthPadding, width - widthPadding,
            //         inY, box.y, box.y+box.height, heightPadding, height - heightPadding,
            //     )
            // }
            return result;
        }
    }
    faceSmoothing = {
        prevBoxArr: [],
        easing: {
            // 0~1 사이의 값 (클수록 빠르게 반응)
            coordi: 0.2,
            size: 0.1
        },
        reset: function(){
            if(this.prevBoxArr.length > 0){
                this.prevBoxArr = [];
            }
        },
        lerp: function(start, end, amt) {
            return start + (end - start) * amt;
        },
        smoothBox: function(box, idx) {
            idx = idx || 0;

            let {prevBoxArr, lerp, easing} = this;
            let prevBox = prevBoxArr[idx];
            if (!prevBox) {
                // ObjectProperty 케이스로 변수 저장 후 등록.
                let { x, y, width, height } = box;
                prevBoxArr[idx] = { x, y, width, height };
                return box;
            }

            let result = prevBoxArr[idx] = {
                x: lerp(prevBox.x, box.x, easing.coordi),
                y: lerp(prevBox.y, box.y, easing.coordi),
                width: lerp(prevBox.width, box.width, easing.size),
                height: lerp(prevBox.height, box.height, easing.size),
            };
            return result;
        }
    }

    /**
     * iOS 16 이하 및 iOS 앱 WebView에서 Legacy 모드 강제 사용 여부 체크
     * face-api.js가 OffscreenCanvas 환경에서 instanceof 에러 발생하는 문제 방지
     * iOS 앱은 메인 스레드 환경이므로 Legacy 모드 필수
     * 
     * @returns {boolean} true: Legacy 모드 사용, false: OffscreenCanvas 모드 사용
     */
    _shouldUseLegacyMode() {
        try {
            const ua = navigator.userAgent || '';
            
            // iPad 감지 (macOS처럼 보이지만 터치 가능)
            const isiPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
            
            // iOS 감지
            const isIOS = /iPhone|iPad|iPod/i.test(ua) || isiPadOS;
            
            // iOS가 아니면 OffscreenCanvas 모드 사용 가능
            if (!isIOS) {
                return false;
            }
            
            // iOS 앱 WebView 감지 (최우선 - GrmMediaStreamTrackCanvasWorker와 동일 로직)
            const isIOSWebView = (() => {
                try {
                    // WebView 감지 조건들 (하나라도 참이면 WebView)
                    
                    // 1) window.webkit.messageHandlers 존재 (iOS 앱 브릿지)
                    if (typeof window !== 'undefined' && window.webkit && window.webkit.messageHandlers) {
                        return true;
                    }
                    
                    // 2) navigator.standalone (PWA/WebView에서 true)
                    if (navigator.standalone === true) {
                        return true;
                    }
                    
                    // 3) display-mode: standalone (PWA/WebView)
                    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
                        return true;
                    }
                    
                    // 4) 인앱 브라우저 User Agent 패턴
                    if (/(FBAN|FBAV|FB_IAB|Instagram|Line|KAKAOTALK|NAVER|DaumApps|GSA)/i.test(ua)) {
                        return true;
                    }
                    
                    // 5) User Agent에 Version이 없음 (일부 앱이 제거)
                    if (!/Version\/\d+/i.test(ua)) {
                        return true;
                    }
                    
                    return false;
                } catch (e) {
                    return false;
                }
            })();
            
            // iOS 앱이면 무조건 Legacy 모드 (메인 스레드 환경)
            if (isIOSWebView) {
                console.log('[GrmFaceDetector] iOS WebView detected - Using Legacy mode (main thread environment)');
                return true;
            }
            
            // iOS Safari 웹: 버전 체크
            const safariMatch = ua.match(/Version\/([\d.]+).*Safari/i);
            if (safariMatch) {
                // Major 버전만 추출 (16.6.1 → 16)
                const majorVersion = parseInt(safariMatch[1].split('.')[0]);
                
                // iOS 16 이하: face-api.js instanceof 에러 방지를 위해 Legacy 모드
                if (!isNaN(majorVersion) && majorVersion > 0 && majorVersion <= 16) {
                    console.log(`[GrmFaceDetector] iOS Safari ${majorVersion} detected - Using Legacy mode (face-api.js compatibility)`);
                    return true;
                }
                
                // iOS 17+ Safari 웹: OffscreenCanvas + face-api.js 정상 동작
                console.log(`[GrmFaceDetector] iOS Safari ${majorVersion} detected - Using OffscreenCanvas mode`);
                return false;
            }
            
            // Safari 버전 매치 실패 시 OS 버전으로 추가 체크
            const osMatch = ua.match(/OS ([\d_]+)/i);
            if (osMatch) {
                // Major 버전만 추출 (16_7_11 → 16)
                const osMajorVersion = parseInt(osMatch[1].split('_')[0]);
                if (!isNaN(osMajorVersion) && osMajorVersion > 0 && osMajorVersion <= 16) {
                    console.log(`[GrmFaceDetector] iOS ${osMajorVersion} detected - Using Legacy mode`);
                    return true;
                }
            }
            
            // 버전 감지 실패한 iOS: 안전하게 true 반환 (WebView일 가능성)
            if (isIOS) {
                console.log('[GrmFaceDetector] iOS detected but version unknown - Using Legacy mode (safe fallback)');
                return true;
            }
            
            return false;
        } catch (e) {
            console.warn('[GrmFaceDetector] Version detection failed:', e);
            // 에러 발생 시 안전하게 true 반환 (iOS일 가능성 고려)
            return true;
        }
    }

    async init () {
        // iOS 16 이하 또는 OffscreenCanvas 미지원 시 Legacy 모드 사용
        if (typeof OffscreenCanvas === 'undefined' || this._shouldUseLegacyMode()) {
            console.log('GrmFaceDetector: Delegating to legacy implementation');
            // 레거시 구현체로 위임
            const { default: GrmFaceDetectorLegacy } = await import('./GrmFaceDetectorLegacy.js');
            this.legacyDetector = new GrmFaceDetectorLegacy(this.options);
            await this.legacyDetector.init();
            this.isLegacyMode = true;
            return;
        }

        console.log('GrmFaceDetector: Using OffscreenCanvas implementation');
        this.isLegacyMode = false;

        faceapi.env.setEnv({
            isNodejs: false,
            isBrowser: false, // Web Worker에서는 false
            isMediaNode: false,
        });
        function createCanvas(){
            const cvs = new OffscreenCanvas(1, 1)
            return cvs;
        }
        faceapi.env.monkeyPatch({
            Canvas: OffscreenCanvas,
            // CanvasRenderingContext2D: globalThis.OffscreenCanvasRenderingContext2D,
            Image: OffscreenCanvas,
            ImageData: ImageData, // ImageData 사용
            createCanvasElement: createCanvas,
            createImageElement: createCanvas,
            fetch: fetch,
        });
        faceapi.env.getEnv().CanvasRenderingContext2D = globalThis.OffscreenCanvasRenderingContext2D;

        const opt = Object.assign({
            inputSize: 224, scoreThreshold: 0.01
        }, this.options.detectOptions);
        opt.inputSize = Math.round(opt.inputSize / 32) * 32
        this.detectOptions = new faceapi.TinyFaceDetectorOptions(opt);

        await faceapi.loadTinyFaceDetectorModel('/common/lib/ai-models/face-api/tiny_face_detector');

        this.setOptions(this.options);
    }

    async setOptions(options) {
        // 레거시 모드인 경우 위임
        if (this.isLegacyMode && this.legacyDetector) {
            return await this.legacyDetector.setOptions(options);
        }

        // faceImage
        await (async () => {
            if(!options.faceImage){
                return;
            }
            try{
                options.faceImage = await createImageBitmap(options.faceImage);
            }catch(e){
                console.error(e);
            }
        })();

        super.setOptions(options);
    }

    async render ({image, canvas, ctx}) {
        // 레거시 모드인 경우 위임
        if (this.isLegacyMode && this.legacyDetector) {
            return await this.legacyDetector.render({ image, canvas, ctx });
        }

        const {drawType} = this.options;
        if(!drawType) return;

        [image, canvas].forEach(obj => {
            if(!obj) return;
            Object.assign(obj, {
                complete: true,
                naturalWidth: obj.width,
                naturalHeight: obj.height,
                videoWidth: obj.width,
                videoHeight: obj.height,
            });
        });

        let numberOfFace = this.options.numberOfFace || 1;
        const detections = await (async () => {
            if(numberOfFace === 1){
                const detection = await faceapi.detectSingleFace(image, this.detectOptions);
                return detection ? [detection] : [];
            }else{
                const list = await faceapi.detectAllFaces(image, this.detectOptions);
                return list;
            }
        })();


        if(detections.length === 0){
            this.confidence.reset();
            this.faceSmoothing.reset();
            return;
        }

        const now = Date.now();
        let limitScore = this.options.limitScore || 0.1;
        detections.forEach((detection, idx, arr) => {
            if(idx >= numberOfFace){
                return;
            }

            if(detection.score < limitScore){
                // console.log('@@ score:', detection.score)
                return;
            }
            // console.log('@@@@@', detection.score);

            if (detection.score <= 0.1) {
                const {confidence} = this;
                if(confidence.isAreaDetected(ctx.canvas, detection.box, 0.8)){
                    // console.log('@@@@@ center1: detectCnt[%s] score[%s]', confidence.detected, detection.score)
                    return;
                }

                if (confidence.detected === 0) {
                    confidence.detected = 1;
                    confidence.lastDetectedTime = now;
                    return false;
                }

                let time = now - confidence.lastDetectedTime;
                if (time > confidence.cooldownTime) {
                    if(confidence.isAreaDetected(ctx.canvas, detection.box, 0.8)){
                        // console.log('@@@@@ center2: detectCnt[%s] score[%s]', confidence.detected, detection.score)
                        confidence.detected = 0;
                        return;
                    }
                    confidence.detected = 1;
                } else {
                    confidence.detected++;
                }

                if (
                    detection.score < 0.3
                    // && confidence.detected < 10
                    && time < 330
                ) {
                    return false;
                }else if (
                    detection.score < 0.4
                    // && confidence.detected < 5
                    && time < 160
                ) {
                    return false;
                }else if (
                    detection.score < 0.5
                    // && confidence.detected < 2
                    && time < 70
                ) {
                    return false;
                }
                // console.log('@@@@@ detectCnt[%s] score[%s]', confidence.detected, detection.score)
            }else{
                this.confidence.detected++;
            }
            // console.log('@@@@@ v: detectCnt[%s] score[%s]', this.confidence.detected, detection.score)

            switch(drawType){
                case 'FaceImage':
                case 'faceImage': {
                    this.renderFaceImage({canvas, ctx, detection});
                    break;
                }
                case 'box': {
                    if(idx === 0){
                        ctx.save();
                        ctx.strokeStyle = 'red';
                        ctx.lineWidth = 2;
                    }

                    let { x, y, width, height } = this.faceSmoothing.smoothBox(detection.box, idx);
                    ctx.strokeRect(x, y, width, height);

                    if(idx === arr.length-1){
                        ctx.restore();
                    }
                    break;
                }
                case 'mosaic': {
                    this.renderFaceMosaic({canvas, ctx, detection});
                }
            }
        });
    }

    renderFaceImage ({ctx, detection, idx}) {
        if(!detection) return;
        const {faceImage} = this.options;
        if(!faceImage) return;

        const {faceSmoothing} = this;

        let { x, y, width, height } = faceSmoothing.smoothBox(detection.box, idx);
        // console.log(x, y, width, height)

        let p = 1.5;
        let ratio = Math.min(
            width/faceImage.width,
            height/faceImage.height
        ) * p;

        let faceWidth = faceImage.width * ratio;
        let faceHeight = faceImage.height * ratio;
        x -= (faceWidth - width) / 2;
        y -= (faceHeight - height) / 2;

        ctx.drawImage(
            faceImage,
            0, 0,
            faceImage.width, faceImage.height,
            x, y,
            faceWidth, faceHeight
        )
    }

    renderFaceMosaic ({ctx, detection, idx}) {
        let { x, y, width, height } = this.faceSmoothing.smoothBox(detection.box, idx);
        (() => {
            let ratio = 1.5;
            let w = width * 1.5;
            let h = height * 1.5;
            x -= (w - width) / 2;
            y -= (h - height) / 2;
            width = w;
            height = h;
        })();

        const mCvs = this._m_cvs = this._m_cvs || new OffscreenCanvas(ctx.canvas.width, ctx.canvas.height);
        const mCtx = this._m_cvs_ctx = this._m_cvs_ctx || (() => {
            const ctx = mCvs.getContext('2d');
            ctx.filter = `blur(20px)`
            return ctx
        })();
        if(mCvs.width < width){
            mCvs.width = width;
        }
        if(mCvs.height < height){
            mCvs.height = height;
        }
        mCtx.drawImage(ctx.canvas,
            x, y, width, height,
            0, 0, width, height,
        );
        ctx.drawImage(mCvs,
            0, 0, width, height,
            x, y, width, height
        );
    }

    // trackApp 인터페이스 메서드들
    async setFaceImage(faceImage) {
        console.log('GrmFaceDetector.setFaceImage called, isLegacyMode:', this.isLegacyMode);
        
        // 레거시 모드인 경우 위임
        if (this.isLegacyMode && this.legacyDetector) {
            console.log('Delegating to legacy detector');
            return await this.legacyDetector.setFaceImage(faceImage);
        }
        
        // OffscreenCanvas 모드
        if (this.options) {
            // URL 문자열인 경우 ImageBitmap으로 변환
            if (typeof faceImage === 'string') {
                try {
                    const response = await fetch(faceImage);
                    const blob = await response.blob();
                    const bitmap = await createImageBitmap(blob);
                    this.options.faceImage = bitmap;
                    console.log('✅ faceImage converted to ImageBitmap');
                } catch (error) {
                    console.error('❌ Failed to convert faceImage:', error);
                    this.options.faceImage = null;
                }
            } else {
                this.options.faceImage = faceImage;
            }
        }
        
        console.log('setFaceImage completed');
    }

    setFaceDrawType(drawType) {
        console.log('GrmFaceDetector.setFaceDrawType called with:', drawType);
        
        // 레거시 모드인 경우 위임
        if (this.isLegacyMode && this.legacyDetector) {
            console.log('Delegating to legacy detector');
            return this.legacyDetector.setFaceDrawType(drawType);
        }
        
        // 기존 OffscreenCanvas 모드에서는 options에 저장
        if (this.options) {
            this.options.drawType = drawType;
        }
        
        console.log('setFaceDrawType completed');
    }
}
GrmMediaPipeObject.add('FaceDetector', GrmFaceDetector);